import axios from 'axios';
import { API_URL } from '../../../config/config';

// Service to get category dropdown
const getCategoryDropdwon = async () => {
	const MasterTypeId = '1';
	const response = await axios.post(`${API_URL}/master/get/master-entry-dropdown`, {
		MasterTypeId,
	});
	return response.data;
};

// service to get SubCategories
const getSubCategoryDropdwon = async (ParentId) => {
	const MasterTypeId = '2';
	const response = await axios.post(`${API_URL}/master/get/master-entry-dropdown`, {
		MasterTypeId,
	});
	return response.data;
};

// service to get Sizes
const getSizeDropdwon = async () => {
	const MasterTypeId = '3';
	const response = await axios.post(`${API_URL}/master/get/master-entry-dropdown`, {
		MasterTypeId,
	});
	return response.data;
};

// service to get COLOR
const getColorDropdown = async () => {
	const MasterTypeId = '4';
	const response = await axios.post(`${API_URL}/master/get/master-entry-dropdown`, {
		MasterTypeId,
	});
	return response.data;
};

// service to get BRAND
const getBrandDropdown = async () => {
	const MasterTypeId = '5';
	const response = await axios.post(`${API_URL}/master/get/master-entry-dropdown`, {
		MasterTypeId,
	});
	return response.data;
};

// service to get STYLE CODE
const getStyleCodeDropdown = async () => {
	const MasterTypeId = '6';
	const response = await axios.post(`${API_URL}/master/get/master-entry-dropdown`, {
		MasterTypeId,
	});
	return response.data;
};

// service to get STYLE CODE
const getLabelTypeDropdown = async () => {
	const MasterTypeId = '7';
	const response = await axios.post(`${API_URL}/master/get/master-entry-dropdown`, {
		MasterTypeId,
	});
	return response.data;
};

const dropdownService = {
	getCategoryDropdwon,
	getSubCategoryDropdwon,
	getSizeDropdwon,
	getColorDropdown,
	getBrandDropdown,
	getStyleCodeDropdown,
	getLabelTypeDropdown,
};

export default dropdownService;
